import { DateTime } from "luxon";

/**
 * Turn a DateTime into a TimeOnly string "HH:mm:ss".
 * UTC, so it matches what formatDatesForTimeOnlyModel sends on the online path.
 */
export function formatTimeOnly(time: DateTime): string {
  return time.toUTC().toFormat('HH:mm:ss');
}
